import styled, { css } from 'styled-components';

import { darkOnly } from '../../styles/mixins';

const Container = styled.footer`
  width: calc(100% + 8rem);
  margin-left: -4rem;
  margin-top: 6rem;
  padding: 4.8rem 4rem 3rem;
  border-top: 1px solid var(--border);
  background-color: var(--surface);

  @media (max-width: 1080px) {
    width: calc(100% + 4rem);
    margin-left: -2rem;
    padding: 4rem 2rem 2.4rem;
  }
`;

const Grid = styled.div`
  max-width: var(--content-max);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.6fr repeat(4, 1fr);
  gap: 2.8rem;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem 2rem;
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const Brand = styled.div`
  @media (max-width: 980px) {
    grid-column: 1 / -1;
  }
`;

const Logo = styled.img`
  width: 9.6rem;
`;

const BrandText = styled.p`
  font-size: 1.35rem;
  line-height: 1.6;
  color: var(--ink-soft);
  max-width: 34ch;
  margin-top: 1.4rem;
`;

const SocialIconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  margin-top: 2rem;

  a {
    display: flex;
    color: var(--ink-soft);
    transition: color var(--dur-fast) var(--ease-standard);

    :hover {
      color: var(--accent);
    }
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ColumnTitle = styled.h4`
  font-size: 1.25rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--ink-faint);
  font-weight: 600;
  margin-bottom: 1.4rem;
`;

const footerItem = `
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0.5rem 0;
  text-align: left;
`;

const NavButton = styled.button`
  ${footerItem}
  height: auto;
  border: none;
  background: transparent;
  color: var(--ink-soft);
  transition: color var(--dur-fast) var(--ease-standard);

  :hover {
    color: var(--ink);
  }
`;

const ExternalLink = styled.a`
  ${footerItem}
  color: var(--ink-soft);
  transition: color var(--dur-fast) var(--ease-standard);

  :hover {
    color: var(--ink);
  }
`;

const Bottom = styled.div`
  max-width: var(--content-max);
  margin: 3.6rem auto 0;
  padding-top: 2rem;
  border-top: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.4rem;
`;

const Copyright = styled.p`
  font-size: 1.25rem;
  color: var(--ink-faint);
`;

const PaymentMethods = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

const SafePaymentText = styled.span`
  font-size: 1.25rem;
  color: var(--ink-faint);
  margin-right: 0.4rem;
`;

const PaymentMethodSvg = styled.img`
  height: 2.2rem;
  opacity: 0.85;

  /* Bandeiras são artes escuras de terceiros: no tema escuro elas somem no
     fundo, então viram versão clara. */
  ${darkOnly(css`
    filter: brightness(0) invert(1);
    opacity: 0.7;
  `)}
`;

export {
  Bottom,
  Brand,
  BrandText,
  Column,
  ColumnTitle,
  Container,
  Copyright,
  ExternalLink,
  Grid,
  Logo,
  NavButton,
  PaymentMethods,
  PaymentMethodSvg,
  SafePaymentText,
  SocialIconsContainer,
};
